function getTitle (vm) {
    const { title } = vm.$options;
    if (title) {
        const resolvedTitle = typeof title === 'function'
            ? title.call(vm)
            : title

        if (typeof resolvedTitle === 'string' && vm.$te && vm.$te(resolvedTitle)) {
            return vm.$t(resolvedTitle)
        }

        return resolvedTitle
    }

    if (vm.$route && vm.$route.meta && vm.$route.meta.title) {
        const routeTitle = vm.$route.meta.title
        if (typeof routeTitle === 'string' && vm.$te && vm.$te(routeTitle)) {
            return vm.$t(routeTitle)
        }

        return routeTitle
    }
}

export default {
    created () {
        const title = getTitle(this);
        if (title) {
            document.title = title
        }
    }
}